module.exports = __webpack_public_path__ + "img/pay-welfare-btn-icon.7fde2263.png";